import React from 'react'
import PropTypes from 'prop-types'

const SearchButtons = ({search,searchRun,reset,buttonsDisabled}) => {
  return (
    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
      <span style={{display: 'block', height: '1.7em'}}>&nbsp;</span>
      <div id="buttons" className="btn-group" role="group"
           style={{zIndex:'1',display:'inline-block'}}>
        <button
          type="button"
          tabIndex={0}
          role="button"
          aria-pressed={searchRun}
          onClick={search}
          className="btn btn-primary"
          disabled={buttonsDisabled}>Search
        </button>
        <button
          type="button"
          tabIndex={1}
          role="button"
          className="btn btn-default"
          onClick={reset}>Reset
        </button>
      </div>
    </div>
  )
};

SearchButtons.propTypes = {
  search: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  searchRun: PropTypes.bool.isRequired,
  searchDisabled: PropTypes.bool.isRequired,
  resetDisabled: PropTypes.bool.isRequired
};
SearchButtons.defaultProps = {
  searchDisabled: true,
  resetDisabled: true,
  searchRun: false
};

export default SearchButtons;


// WEBPACK FOOTER //
// ./src/components/SearchButtons.jsx